export default {
  ID_CHECK: 'ID-CHECK',
  AGE_RESTRICTED_FOR_CHECK: 'AGE-RESTRICTED-CHECK',
  AGE_RESTRICTED_FOR_SEAT: 'AGE-RESTRICTED-SEAT',
  STORE_PRODUCTION: 'STORE-PRODUCTION',
};
